import i18n from '@/utils/i18n';
import React from 'react';
import { BaseActionSheet } from '@/components/base-action-sheet';
import { createStyles } from '@/contexts/theme-context';
import { Dimensions, ScrollView, View } from 'react-native';
import { Typography } from '@usepepper/ui/atoms/typography';
import { useLayoutContext } from '@/contexts/layout-context';

interface Props {
  isVisible: boolean;
  notes: string;
  onClose: () => void;
}

export const OrderItemNoteSheet: React.FC<Props> = ({
  isVisible,
  notes,
  onClose,
}) => {
  const [styles] = useStyles();
  const { isSmallLayout } = useLayoutContext();

  return (
    <BaseActionSheet
      contentStyle={styles.sheetContent}
      isVisible={isVisible}
      onClose={onClose}
      title={i18n.t('item_note')}
    >
      {isSmallLayout ? (
        <Typography variant="heading-lg">{i18n.t('item_note')}</Typography>
      ) : null}
      <View style={styles.noteWrapper}>
        <ScrollView
          contentContainerStyle={styles.noteScrollContent}
          style={[
            styles.noteScroll,
            isSmallLayout
              ? { maxHeight: Dimensions.get('window').height * 0.3 }
              : null,
          ]}
        >
          <Typography variant="paragraph-base">{notes}</Typography>
        </ScrollView>
      </View>
    </BaseActionSheet>
  );
};

const useStyles = createStyles((theme) => ({
  noteScroll: {
    maxHeight: 340,
    minHeight: 96,
  },
  noteScrollContent: {
    flexGrow: 1,
  },
  noteWrapper: {
    backgroundColor: theme.sk.color.bg.primary.default,
    borderColor: theme.sk.color.border.primary,
    borderRadius: theme.sk.radii.radiusMedium,
    borderWidth: 1,
    padding: theme.sk.spacing.spaceMedium,
  },
  sheetContent: {
    gap: theme.sk.spacing.spaceMedium,
  },
}));
